import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/Pages/login.vue'
import PassChange from '@/Pages/passChange.vue'
import RegisterItem from '@/Pages/registerItem.vue'
import ItemList from '@/Pages/itemList.vue'
import AuctionRegister from '@/Pages/auctionRegister.vue'
import UserSetting from '@/Pages/userSetting.vue'
import CreateUser from '@/Pages/createUser.vue'
import Sell from '@/Pages/sell.vue'
import ErrCheck from '@/Pages/errCheck.vue'
import ShipCsv from '@/Pages/shipCsv.vue'
import Inquiry from '@/Pages/inquiry.vue'
import Infomation from '@/Pages/infomation.vue'
import CopyItem from '@/Pages/copyItem.vue'
import SelectItem from '@/Pages/selectItem.vue'
import FixedPhrase from '@/Pages/fixedPhrase.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/passChange',
    name: 'PassChange',
    component: PassChange
  },
  {
    path: '/registerItem/:id/:pageNum',
    name: 'RegisterItem',
    component: RegisterItem,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/itemList/:pageNum',
    name: 'ItemList',
    component: ItemList,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/auctionRegister',
    name: 'AuctionRegister',
    component: AuctionRegister,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/userSetting',
    name: 'UserSetting',
    component: UserSetting,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/createUser',
    name: 'CreateUser',
    component: CreateUser,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/sell',
    name: 'Sell',
    component: Sell,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/errCheck',
    name: 'ErrCheck',
    component: ErrCheck,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/trading',
    name: 'trading',
    component: ShipCsv,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/inquiry',
    name: 'Inquiry',
    component: Inquiry,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/infomation',
    name: 'Infomation',
    component: Infomation,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/copyItem',
    name: 'CopyItem',
    component: CopyItem,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/selectItem',
    name: 'SelectItem',
    component: SelectItem,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/fixedPhrase',
    name: 'fixedPhrase',
    component: FixedPhrase,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/*',
    name: 'Login',
    component: Login
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: '/TOOL',
  routes
})
router.beforeEach (async (to, from, next) => {
  let vm = Vue.prototype
  var auth = vm.$functions.isAuth()
  if (to.matched.some(record => record.meta.requiresAuth) && !auth) {
    next({ path: '/', query: { redirect: to.fullPath }});
  } else {
    next()
  }
});
export default router
